export const renderEmoji = (codepoints) => {
  if (!codepoints) return '';
  return String.fromCodePoint.apply(null, codepoints.split(' ').map((c) => {
    return parseInt(c, 16)
  }))
}

export const getVariantLabelName = (parent, emoji) => {
  return emoji.name.replace(`${parent.name}: `, '');
}

export const getVariantLabelSlug = (parent, emoji) => {
  const slug = getVariantLabelName(parent, emoji).replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
  return `${slug}-${emoji.id.split('-')[0]}`
}